import { verificationQueryKeys as e } from "./useVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/useRequestBusinessDocumentRemovalMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.requestBusinessDocumentRemoval,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.business() });
		}
	});
};
//#endregion
export { i as useRequestBusinessDocumentRemovalMutation };
